import { pdkAxios } from '@/lib/pdk-axios';
import { auctionStore } from '@/models/stores';
import type { Auction } from '@/models/types';
import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import { toast } from './use-toast';

export const useCreateAuctionMutation = ({
  onSuccess,
}: {
  onSuccess?: (auction: Auction) => void;
} = {}) => {
  const createAuctionMutation = useMutation({
    mutationFn: async (params: { id: string; name: string }) => {
      const response = await pdkAxios.post('/auctions/create', params);
      return response.data;
    },
    onSuccess: (auction) => {
      // Add to store
      auctionStore.add(auction);

      toast({
        title: 'Auction created successfully',
      });

      if (onSuccess) {
        onSuccess(auction);
      }
    },
    onError: (error: AxiosError | Error) => {
      toast({
        title: 'Error creating auction',
        description:
          error instanceof AxiosError
            ? error.response?.data.error
            : error.message,
        variant: 'destructive',
      });
    },
  });

  return { createAuctionMutation };
};
